module.exports = __webpack_public_path__ + "assets/img/352def12e9208e38de28de55c6dcad3a.png";